export default __webpack_public_path__ + "static/media/13.c10d7a7b.svg";